import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import { db } from "@/firebase";

Vue.use(Vuex);

const userState = new createPersistedState({
  path: ["role", "location", "filterLocation"],
});

export const store = new Vuex.Store({
  state: {
    firstName: "",
    lastName: "",
    role: "",
    country: "",
    group: "",
    email: "",
    location: "",
    filterLocation: "",
    locations: [],
    loadingFulfilledOrders: false,
    fulfilledOrders: [],
    loadingOpenOrders: false,
    openOrders: [],
  },
  getters: {},
  mutations: {
    SET_USER: (state, userData) => {
      state.firstName = userData.firstName;
      state.lastName = userData.lastName;
      state.role = userData.role;
      state.country = userData.country;
      state.group = userData.group;
      state.email = userData.email;
      state.location = userData.location;
      state.filterLocation = userData.location;
    },
    SET_FILTER_LOC: (state, data) => {
      state.filterLocation = data;
    },
    RESET_STORE: (state) => {
      state.firstName = "";
      state.lastName = "";
      state.role = "";
      state.country = "";
      state.group = "";
      state.email = "";
      state.location = "";
    },
  },
  actions: {
    // eslint-disable-next-line
    LOAD_LOCATIONS({ commit, state }) {
      db.collection("locations")
        .orderBy("country")
        .get()
        .then((querySnapshot) => {
          const locations = [];
          querySnapshot.forEach((locationDoc) => {
            locations.push(locationDoc.data());
          });
          state.locations = locations;
        });
    },
    // eslint-disable-next-line
    setFilterLocation({ commit }, data) {
      commit("SET_FILTER_LOC", data);
    },
  },
  plugins: [userState],
});
